<span class="-pill -fontMedium -canclick">
  @if (icon) {
    <span>
      <img [src]="'assets/images/country-icons/'+icon+'.svg'" [alt]="icon"/>
    </span>
  }
  <ng-container *ngTemplateOutlet="content"></ng-container>
  @if (disable) {
    <span class="-disable-pill">
      <lucide-icon name="circle-x" size="16"></lucide-icon>
    </span>
  }
</span>
<ng-template #content>
  <ng-content></ng-content>
</ng-template>
